/*******************************************************************************
* Copyright (c) 2023 GetChkd
*
* All rights reserved.
*
* Contributors:
*  James Worthington - Initial implementation
*  Amina Rais - Massive Improvements
*  Version: 2.0.0
*
*******************************************************************************/

export const TimestampToDate = (timestamp) => {
    const createdTimestamp = timestamp;
    const formattedDate = new Date(createdTimestamp).toLocaleString(); // Convert to human-readable date

    return formattedDate;
};

